export default "__VITE_ASSET__P9jNH34A__"